import {
	EXIT_VEHICLE_CONFIGURATION,
	ADD_VEHICLE_OVERVIEW,
	SHOW_MODAL,
	HIDE_MODAL,
	SET_PERSPECTIVE,
	ADD_MOTORYCLE_MODELS,
	SELECT_PART,
	DESELECT_PART,
	SELECT_SETUP,
	APPLY_SETUP,
	APPLY_PARTS,
	SHOW_TOAST,
	HIDE_TOAST,
	REMOVE_ALL_PARTS,
	SET_PRICE,
	SET_CREATED_CONFIGURATION,
	SET_IMAGE_TIMESTAMP,
	SET_CONFIGURATION_ID,
	SET_CONFIGURATION_IMAGES,
	TOGGLE_CONFIG_SUMMARY,
	TOGGLE_PART_DETAIL,
	PRESERVE_SAVE_DETAILS_DATA,
	CATEGORY_SCROLL_POSITION,
	SET_CONFIGURATION_WAS_RECENTLY_CREATED,
	SET_CONFIGURATION_IS_DIRTY
} from "./actionTypes";
import {
	MotorcycleModelResponse,
	Price
} from "../components/main/motorcycles/MotorcycleView";
import { Part } from "../components/parts/PartsList";
import { DialogTypes } from "../enums/dialogTypes";
import { Setup } from "../components/setups/SetupsList";
import { VehicleOverviewState } from "./reducers/vehicleOverview";
import {
	CreateConfigurationResponse,
	FullImage
} from "../components/configuration/ConfigurationView";
import { SaveDetailsData } from "../components/dialogs/saveConfiguration";

export const exitVehicleConfiguration = () => ({
	type: EXIT_VEHICLE_CONFIGURATION
});

/* BIKE OVERVIEW */
export const addVehicleOverview = (payload: VehicleOverviewState) => ({
	type: ADD_VEHICLE_OVERVIEW,
	payload
});

export interface ShowDialogProps<D = any> {
	contentType: DialogTypes;
	data: D;
	title: string;
}

/* MODALS */
export const showDialog = ({ contentType, data, title }: ShowDialogProps) => ({
	type: SHOW_MODAL,
	payload: {
		contentType,
		data,
		title
	}
});

export const hideDialog = () => ({
	type: HIDE_MODAL,
	payload: null
});

/* MODELS */
export const addMotorcycleModels = (payload: MotorcycleModelResponse) => ({
	type: ADD_MOTORYCLE_MODELS,
	payload
});

/* CONFIGURATION */
export const setPerspective = (perspective: number) => ({
	type: SET_PERSPECTIVE,
	payload: perspective
});

export const addCreatedConfiguration = (
	payload: CreateConfigurationResponse
) => ({
	type: SET_CREATED_CONFIGURATION,
	payload
});

export const setConfigurationId = (payload: number) => ({
	type: SET_CONFIGURATION_ID,
	payload
});

export const addPrice = (payload: Price) => ({
	type: SET_PRICE,
	payload
});

export const setImageTimestamp = () => ({
	type: SET_IMAGE_TIMESTAMP
});

export const setConfigurationImages = (payload: FullImage[]) => ({
	type: SET_CONFIGURATION_IMAGES,
	payload
});

export const setCategoryScrollPosition = (payload: number) => ({
	type: CATEGORY_SCROLL_POSITION,
	payload
});

export const setConfigurationWasRecentlyCreated = (payload: boolean) => ({
	type: SET_CONFIGURATION_WAS_RECENTLY_CREATED,
	payload
});

export const setConfigurationIsDirty = (payload: boolean) => ({
	type: SET_CONFIGURATION_IS_DIRTY,
	payload
})

/* PARTS */
export const selectPart = (payload: Part) => ({
	type: SELECT_PART,
	payload
});
export const deselectPart = () => ({
	type: DESELECT_PART
});

export const applyParts = (payload: string[]) => ({
	type: APPLY_PARTS,
	payload
});

export const removeAllParts = () => ({
	type: REMOVE_ALL_PARTS
});

/* SETUPS */
export const selectSetup = (payload: Setup) => ({
	type: SELECT_SETUP,
	payload
});

export const applySetup = (payload: Setup) => ({
	type: APPLY_SETUP,
	payload
});

/* TOAST */
export const showToast = (payload: string) => ({
	type: SHOW_TOAST,
	payload
});

export const hideToast = () => ({
	type: HIDE_TOAST
});

/* VIEWS */

export const toggleSummary = (payload: boolean) => ({
	type: TOGGLE_CONFIG_SUMMARY,
	payload
});

export const togglePartDetail = (payload: boolean) => ({
	type: TOGGLE_PART_DETAIL,
	payload
});

export const preserveSaveDetailsData = (payload: SaveDetailsData) => ({
	type: PRESERVE_SAVE_DETAILS_DATA,
	payload
});
